// Every employmentStatus option must appear in exactly one of these lists.
export const NO_EMPLOYER_INFO_STATUSES = ['notEmployed', 'retired'];
export const EMPLOYER_INFO_STATUSES = ['employed', 'student', 'other'];
